import _regeneratorRuntime from 'babel-runtime/regenerator';

var _createActions2, _handleActions, _handleActions2;

var requestResource = function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resourceId, options) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(process.env.NODE_ENV === 'production')) {
              _context.next = 2;
              break;
            }

            return _context.abrupt('return', cachedFetch(resourceId));

          case 2:
            return _context.abrupt('return', fetch(resourceId).then(function (resp) {
              return resp.json();
            }));

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function requestResource(_x4, _x5) {
    return _ref6.apply(this, arguments);
  };
}();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(errorAction),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(successAction),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(requestIiifResource),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(importResource),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(importPresentation2Resource),
    _marked6 = /*#__PURE__*/_regeneratorRuntime.mark(importPresentation3Resource),
    _marked7 = /*#__PURE__*/_regeneratorRuntime.mark(getResourceType),
    _marked8 = /*#__PURE__*/_regeneratorRuntime.mark(getPresentation2ResourceType),
    _marked9 = /*#__PURE__*/_regeneratorRuntime.mark(getPresentation3ResourceType),
    _marked10 = /*#__PURE__*/_regeneratorRuntime.mark(requestUnknownResource),
    _marked11 = /*#__PURE__*/_regeneratorRuntime.mark(saga);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

import cachedFetch from 'fetch-unless-cached';
import { createActions, handleActions } from 'redux-actions';
import validUrl from 'valid-url';
import { call, put, select, takeEvery, all } from 'redux-saga/effects';
import deepmerge from 'deepmerge';
import update from 'immutability-helper';
import * as presentation2 from '../schema/presentation2';
import * as presentation3 from '../schema/presentation3';
import trackPresentationVersion from '../utility/trackPresentationVersion';
import { COLLECTION_ERROR, COLLECTION_REQUEST, COLLECTION_SUCCESS } from './collections';
import { MANIFEST_ERROR, MANIFEST_REQUEST, MANIFEST_SUCCESS } from './manifests';
import getPresentationVersionFromResource from '../utility/getPresentationVersionFromResource';
var debug = require('debug')('iiif-redux');

var IIIF_RESOURCE_REQUEST = 'IIIF_RESOURCE_REQUEST';
var IIIF_RESOURCE_SUCCESS = 'IIIF_RESOURCE_SUCCESS';
var IIIF_RESOURCE_ERROR = 'IIIF_RESOURCE_ERROR';
var IIIF_RESOURCE_REQUEST_UNKNOWN = 'IIIF_RESOURCE_REQUEST_UNKNOWN';
var IIIF_RESOURCE_IDENTIFY = 'IIIF_RESOURCE_IDENTIFY';

var DEFAULT_MAPPINGS = {
  collection: [COLLECTION_REQUEST, COLLECTION_SUCCESS, COLLECTION_ERROR],
  manifest: [MANIFEST_REQUEST, MANIFEST_SUCCESS, MANIFEST_ERROR]
};

var _createActions = createActions((_createActions2 = {}, _createActions2[IIIF_RESOURCE_REQUEST_UNKNOWN] = function (resourceId) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var mappings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_MAPPINGS;
  return {
    resourceId: resourceId,
    dereferenceIfMissing: options.dereferenceIfMissing || false,
    ttl: options.ttl || 600,
    forceFresh: options.forceFresh,
    mappings: mappings
  };
}, _createActions2[IIIF_RESOURCE_REQUEST] = function (resourceId, types, schema) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return {
    resourceId: resourceId,
    types: types,
    schema: schema,
    dereferenceIfMissing: options.dereferenceIfMissing || false,
    ttl: options.ttl || 600,
    forceFresh: options.forceFresh
  };
}, _createActions2[IIIF_RESOURCE_SUCCESS] = function (resourceId, normalizedResponse) {
  return {
    resourceId: resourceId,
    normalizedResponse: normalizedResponse
  };
}, _createActions2[IIIF_RESOURCE_ERROR] = function (resourceId, error) {
  return {
    resourceId: resourceId,
    error: error
  };
}, _createActions2)),
    iiifResourceRequestUnknown = _createActions.iiifResourceRequestUnknown,
    iiifResourceRequest = _createActions.iiifResourceRequest,
    iiifResourceSuccess = _createActions.iiifResourceSuccess,
    iiifResourceError = _createActions.iiifResourceError;

var DEFAULT_STATE = {
  dereferenced: {},
  resources: {
    collections: {},
    sequences: {},
    manifests: {},
    canvases: {},
    canvasReferences: {},
    annotations: {},
    annotationLists: {},
    annotationPages: {},
    annotationCollections: {},
    ranges: {},
    layers: {},
    imageResources: {},
    externalResources: {},
    contentResources: {},
    choices: {}
  }
};

var resourceReducer = handleActions((_handleActions = {}, _handleActions[iiifResourceSuccess] = function (state, _ref) {
  var normalizedResponse = _ref.payload.normalizedResponse;
  return deepmerge(state, normalizedResponse);
}, _handleActions), DEFAULT_STATE.resources);

var dereferencedReducer = handleActions((_handleActions2 = {}, _handleActions2[iiifResourceRequest] = function (state, _ref2) {
  var _update;

  var _ref2$payload = _ref2.payload,
      resourceId = _ref2$payload.resourceId,
      ttl = _ref2$payload.ttl;
  return update(state, (_update = {}, _update[resourceId] = {
    $set: {
      resourceId: resourceId,
      ttl: ttl,
      requested: state[resourceId] ? state[resourceId].requested : new Date(),
      loading: state[resourceId] ? state[resourceId].loading : true
    }
  }, _update));
}, _handleActions2[iiifResourceRequestUnknown] = function (state, _ref3) {
  var _update2;

  var _ref3$payload = _ref3.payload,
      resourceId = _ref3$payload.resourceId,
      ttl = _ref3$payload.ttl;
  return update(state, (_update2 = {}, _update2[resourceId] = {
    $set: {
      resourceId: resourceId,
      ttl: ttl,
      loading: state[resourceId] ? state[resourceId].loading : true
    }
  }, _update2));
}, _handleActions2[iiifResourceError] = function (state, _ref4) {
  var _update3;

  var _ref4$payload = _ref4.payload,
      resourceId = _ref4$payload.resourceId,
      error = _ref4$payload.error;
  return update(state, (_update3 = {}, _update3[resourceId] = {
    loading: { $set: false },
    error: { $set: error }
  }, _update3));
}, _handleActions2[iiifResourceSuccess] = function (state, _ref5) {
  var _update4;

  var resourceId = _ref5.payload.resourceId;
  return update(state, (_update4 = {}, _update4[resourceId] = {
    loading: { $set: false }
  }, _update4));
}, _handleActions2), DEFAULT_STATE.dereferenced);

function errorAction(type, resourceId, error) {
  return _regeneratorRuntime.wrap(function errorAction$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return put(iiifResourceError(resourceId, error));

        case 2:
          if (!type) {
            _context2.next = 5;
            break;
          }

          _context2.next = 5;
          return put({ type: type, payload: { resourceId: resourceId, error: error } });

        case 5:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked, this);
}

function successAction(type, resourceId, normalizedResponse) {
  return _regeneratorRuntime.wrap(function successAction$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return put(iiifResourceSuccess(resourceId, normalizedResponse));

        case 2:
          _context3.next = 4;
          return put({ type: type, payload: { resourceId: resourceId, normalizedResponse: normalizedResponse } });

        case 4:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked2, this);
}

function requestIiifResource(_ref7) {
  var payload = _ref7.payload;

  var resourceId, types, options, REQUEST, SUCCESS, ERROR, state, response, _ref8, result, entities;

  return _regeneratorRuntime.wrap(function requestIiifResource$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          resourceId = payload.resourceId, types = payload.types, options = _objectWithoutProperties(payload, ['resourceId', 'types']);

          if (!(types.length !== 3 && process.env.NODE_ENV !== 'production')) {
            _context4.next = 4;
            break;
          }

          _context4.next = 4;
          return call(errorAction, null, resourceId, 'DEV ERROR: You must pass in exactly 3 action types');

        case 4:
          REQUEST = types[0], SUCCESS = types[1], ERROR = types[2];

          if (validUrl.isWebUri(resourceId)) {
            _context4.next = 9;
            break;
          }

          _context4.next = 8;
          return call(errorAction, ERROR, resourceId, 'Resource is not a valid Web URI.');

        case 8:
          return _context4.abrupt('return');

        case 9:
          _context4.next = 11;
          return select();

        case 11:
          state = _context4.sent;

          if (!(state.dereferenced[resourceId] && state.dereferenced[resourceId].loading === false /*&& options.forceFresh === false*/
          )) {
            _context4.next = 15;
            break;
          }

          debug('Skipping fetch for resource %s using cache.', resourceId);

          return _context4.abrupt('return');

        case 15:
          _context4.next = 17;
          return put({ type: REQUEST, payload: payload });

        case 17:
          _context4.prev = 17;

          debug('Fetching resource %s', resourceId);
          _context4.next = 21;
          return call(requestResource, resourceId, options);

        case 21:
          response = _context4.sent;
          _context4.next = 24;
          return call(importResource, response, resourceId);

        case 24:
          _ref8 = _context4.sent;
          result = _ref8.result;
          entities = _ref8.entities;

          debug('Finished normalize resource %s', result.id);

          _context4.next = 30;
          return call(successAction, SUCCESS, result.id, entities);

        case 30:
          _context4.next = 37;
          break;

        case 32:
          _context4.prev = 32;
          _context4.t0 = _context4['catch'](17);

          debug('Error: %O', _context4.t0);
          _context4.next = 37;
          return call(errorAction, ERROR, resourceId, _context4.t0);

        case 37:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked3, this, [[17, 32]]);
}

function importResource(response, resourceId) {
  var version;
  return _regeneratorRuntime.wrap(function importResource$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          version = getPresentationVersionFromResource(response);

          if (!(version === 2)) {
            _context5.next = 5;
            break;
          }

          _context5.next = 4;
          return call(importPresentation2Resource, response, resourceId);

        case 4:
          return _context5.abrupt('return', _context5.sent);

        case 5:
          _context5.next = 7;
          return call(importPresentation3Resource, response, resourceId);

        case 7:
          return _context5.abrupt('return', _context5.sent);

        case 8:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked4, this);
}

function importPresentation2Resource(response, resourceId) {
  return _regeneratorRuntime.wrap(function importPresentation2Resource$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          if (response['@id'] !== resourceId) {
            // @todo this will not catch "partOf" fields.
            debug('Resource ID does not match requested presentation 2 resource, patching... Found: %s Expected: %s', response['@id'], resourceId);
            response['@id'] = resourceId;
          }

          debug('Starting normalize presentation 2 resource %s', resourceId);

          return _context6.abrupt('return', trackPresentationVersion(2, presentation2.normalize(response, presentation2.resource)));

        case 3:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked5, this);
}

function importPresentation3Resource(response, resourceId) {
  return _regeneratorRuntime.wrap(function importPresentation3Resource$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          if (response.id !== resourceId) {
            // @todo this will not catch "partOf" fields.
            debug('Resource ID does not match requested presentation 3 resource, patching... Found: %s Expected: %s', response.id, resourceId);
            response.id = resourceId;
          }

          debug('Starting normalize presentation 3 resource %s', resourceId);

          return _context7.abrupt('return', trackPresentationVersion(3, presentation3.normalize(response, presentation3.resource)));

        case 3:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked6, this);
}

function getResourceType(resourceId, response) {
  var presentationVersion;
  return _regeneratorRuntime.wrap(function getResourceType$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          presentationVersion = getPresentationVersionFromResource(response);

          if (!(presentationVersion === 2)) {
            _context8.next = 5;
            break;
          }

          _context8.next = 4;
          return call(getPresentation2ResourceType, resourceId, response);

        case 4:
          return _context8.abrupt('return', _context8.sent);

        case 5:
          _context8.next = 7;
          return call(getPresentation3ResourceType, resourceId, response);

        case 7:
          return _context8.abrupt('return', _context8.sent);

        case 8:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked7, this);
}

function getPresentation2ResourceType(resourceId, response) {
  return _regeneratorRuntime.wrap(function getPresentation2ResourceType$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          if (presentation2.RESOURCE_TYPE_MAP[response['@type']]) {
            _context9.next = 2;
            break;
          }

          throw new Error('Unknown Presentation 2 resource type');

        case 2:
          return _context9.abrupt('return', presentation2.RESOURCE_TYPE_MAP[response['@type']]);

        case 3:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked8, this);
}

function getPresentation3ResourceType(resourceId, response) {
  return _regeneratorRuntime.wrap(function getPresentation3ResourceType$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          if (presentation3.RESOURCE_TYPE_MAP[response.type]) {
            _context10.next = 2;
            break;
          }

          throw new Error('Unknown Presentation 3 resource type');

        case 2:
          return _context10.abrupt('return', presentation3.RESOURCE_TYPE_MAP[response.type]);

        case 3:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked9, this);
}

function requestUnknownResource(_ref9) {
  var _ref9$payload = _ref9.payload,
      resourceId = _ref9$payload.resourceId,
      mappings = _ref9$payload.mappings,
      options = _objectWithoutProperties(_ref9$payload, ['resourceId', 'mappings']);

  var response, type, _mappings$type, REQUEST, SUCCESS, ERROR;

  return _regeneratorRuntime.wrap(function requestUnknownResource$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          if (validUrl.isWebUri(resourceId)) {
            _context11.next = 4;
            break;
          }

          _context11.next = 3;
          return put(iiifResourceError(resourceId, 'Resource is not a valid URL.'));

        case 3:
          return _context11.abrupt('return');

        case 4:
          _context11.prev = 4;

          // 1) Request the resource.
          debug('Fetching unknown resource %s', resourceId);
          _context11.next = 8;
          return call(requestResource, resourceId, options);

        case 8:
          response = _context11.sent;

          if (response) {
            _context11.next = 13;
            break;
          }

          _context11.next = 12;
          return put(iiifResourceError(resourceId, new Error('Resource cannot be null or undefined')));

        case 12:
          return _context11.abrupt('return');

        case 13:
          _context11.next = 15;
          return call(getResourceType, resourceId, response);

        case 15:
          type = _context11.sent;

          if (mappings[type]) {
            _context11.next = 20;
            break;
          }

          _context11.next = 19;
          return put(iiifResourceError(resourceId, 'Resource type is not in configured mappings (' + Object.keys(mappings).join(', ') + ')'));

        case 19:
          return _context11.abrupt('return');

        case 20:

          // 3) Grab constants from a map (to be created).
          _mappings$type = mappings[type], REQUEST = _mappings$type[0], SUCCESS = _mappings$type[1], ERROR = _mappings$type[2];

          // 4) Send to regular import (will be cached).

          _context11.next = 23;
          return put(iiifResourceRequest(resourceId, [REQUEST, SUCCESS, ERROR]));

        case 23:
          _context11.next = 29;
          break;

        case 25:
          _context11.prev = 25;
          _context11.t0 = _context11['catch'](4);
          _context11.next = 29;
          return put(iiifResourceError(resourceId, _context11.t0.message));

        case 29:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked10, this, [[4, 25]]);
}

function saga() {
  return _regeneratorRuntime.wrap(function saga$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return all([takeEvery(IIIF_RESOURCE_REQUEST, requestIiifResource), takeEvery(IIIF_RESOURCE_REQUEST_UNKNOWN, requestUnknownResource)]);

        case 2:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked11, this);
}

export { saga, resourceReducer, dereferencedReducer, iiifResourceRequest, iiifResourceRequestUnknown, DEFAULT_STATE, IIIF_RESOURCE_REQUEST, IIIF_RESOURCE_SUCCESS, IIIF_RESOURCE_ERROR, IIIF_RESOURCE_REQUEST_UNKNOWN, IIIF_RESOURCE_IDENTIFY };